import styled from "styled-components"
import theme from '../../../styles/theme';
import { useNavigate } from 'react-router-dom';

const MenuHeader = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    background: ${theme.color.white[100]};
    // border-bottom: 1px solid ${theme.color.black[10]};// #D5CECF;//
    // border-image-source: linear-gradient(91.1deg, ${theme.color.white[100]} 11.83%, ${theme.color.black[5]} 88.83%) 100% / 40px;
    // box-shadow: ${theme.color.shadow};
    padding: 1rem 0px;
    h2 {
        margin: 0;
        color: ${theme.color.black[80]};
        font-size: ${theme.fontSize.base};
        cursor: pointer;
    }
    h3 {
        margin: 0;
        color: ${theme.color.black[40]};
        font-size: ${theme.fontSize.base};
        font-weight: normal;
        cursor: pointer;
    }
    span {
        font-size: ${theme.fontSize.sm};
    }
`;

const NaviText = ({target}) => {
    const navigate = useNavigate();
    return (
        <MenuHeader>
            <div style={{width:'100%',display:'flex',justifyContent:'flex-start',alignItems:'baseline'}}>
                {target &&
                    target.map((item,index)=>{
                        return index < (target.length - 1) ? (<h3 key={index} onClick={()=>navigate(item.url)}>{item.text}&nbsp;&nbsp;/&nbsp;&nbsp;</h3>) : (<h2 key={index}>{item.text}</h2>)
                        
                    })
                }
            </div>
        </MenuHeader>
    )
}

export default NaviText;
